import { render, staticRenderFns } from "./SummaryOfAdditionalCharges.vue?vue&type=template&id=695664ec&scoped=true"
import script from "./SummaryOfAdditionalCharges.vue?vue&type=script&lang=js"
export * from "./SummaryOfAdditionalCharges.vue?vue&type=script&lang=js"
import style0 from "./SummaryOfAdditionalCharges.vue?vue&type=style&index=0&id=695664ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695664ec",
  null
  
)

export default component.exports